<template functional>
  <nav
    :class="[data.class, data.staticClass, 'sf-breadcrumbs']"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    aria-label="breadcrumb"
    v-on="listeners"
  >
    <ol class="sf-breadcrumbs__list">
      <li
        v-for="(breadcrumb, i) in props.breadcrumbs"
        :key="i"
        class="sf-breadcrumbs__list-item"
        :aria-current="$options.breadcrumbLast(props.breadcrumbs) === i && 'page'"
      >
        <template v-if="$options.breadcrumbLast(props.breadcrumbs) !== i">
          <slot name="link" v-bind="{ breadcrumb }">
            <component
              :is="injections.components.SfLink"
              class="sf-breadcrumbs__breadcrumb"
              :link="breadcrumb.link"
              :data-testid="breadcrumb.text"
            >
              {{ breadcrumb.text }}
            </component>
          </slot>
        </template>
        <template v-else>
          <slot name="current" v-bind="{ breadcrumb }">
            <span class="sf-breadcrumbs__breadcrumb current">
              {{ breadcrumb.text }}
            </span>
          </slot>
        </template>
      </li>
    </ol>
  </nav>
</template>
<script>
import SfLink from '@storefront-ui/vue/src/components/atoms/SfLink/SfLink';
export default {
  name: 'SfBreadcrumbs',
  inject: {
    components: {
      default: { SfLink },
    },
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  breadcrumbLast(breadcrumbs) {
    return breadcrumbs.length - 1;
  },
};
</script>
<style lang="scss" scoped>
.sf-breadcrumbs {
  &__list {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  &__list-item {
    &:not(:last-child) {
      &::after {
        padding: var(--breadcrumbs-list-item-before-padding, 0 var(--spacer-sm));
        content: var(--breadcrumbs-list-item-seperator, '|');
        color: var(--breadcrumbs-list-item-before-color, var(--c-text-muted));
      }
    }
  }
  &__breadcrumb {
    @include font(
      --breadcrumbs-font,
      var(--font-weight--normal),
      var(--font-size--xs),
      1.6,
      var(--font-family--secondary)
    );
    --link-color: var(--c-text-muted);
    --link-text-decoration: none;
    &:hover {
      --link-color: var(--c-text);
    }
    &.current {
      --link-color: var(--c-text);
      cursor: default;
    }
  }
  @include for-desktop {
    --breadcrumbs-font-size: var(--font-size--sm);
  }
}
</style>
